import React from 'react';
import { CircularProgress } from '@material-ui/core';

interface LoadingWrapperProps {
  isLoading: boolean;
  size?: string;
  children: any;
}

const LoadingWrapper = ({
  isLoading,
  size = '1rem',
  children
}: LoadingWrapperProps) => {
  return isLoading ? <CircularProgress size={size} /> : children;
};

export default LoadingWrapper;
